import { PROSPECTS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import prospectsTypes from '../../constants/prospectsTypes'
import { axios } from '../../services'

const resend_request = () => {
  return {
    type: prospectsTypes.resend.request
  }
}

const resend_success = () => {
  return {
    type: prospectsTypes.resend.success
  }
}

const resend_failure = (messages) => {
  return {
    type: prospectsTypes.resend.failure,
    payload: messages
  }
}

const resend_preregistration = (prospect_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(resend_request())

    // Request
    axios.post(
      formatRoute(PROSPECTS_ROUTES.resend, {id: prospect_id})
    ).then( response => {
      // success
      dispatch( resend_success() )
      window.showSnackbar('success', 'A new invitation has been sent to the Prospect')
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error resending invitation"]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( resend_failure(errors))
    })
  }
}

export {
  resend_preregistration,
}



// WEBPACK FOOTER //
// ./src/js/actions/prospects/resend.js